/**
 * Реєструє service worker (public/sw.js) на КОЖНІЙ сторінці застосунку.
 * Викликається з main.ts незалежно від того, яка саме сторінка завантажена.
 *
 * Без зареєстрованого SW і манісфесту (посилання на нього — у <head> кожної
 * сторінки) браузер не пропонує "Встановити застосунок" — тому це і є та
 * сама дія, що дозволяє РАНІШЕ ІСНУЮЧИМ користувачам (які заходили ще до
 * появи PWA) встановити застосунок просто зайшовши на сайт ще раз: нова
 * версія сторінки, яку вони отримають при звичайному заході (сервер і так
 * віддає HTML/JS/CSS без агресивного кешування — src/server.ts), уже містить
 * і манісфест, і цей виклик реєстрації.
 *
 * ВАЖЛИВО: Service Worker вимагає "безпечного контексту" (HTTPS або
 * буквально http://localhost) — якщо застосунок відкрито по IP-адресі в
 * локальній мережі (http://192.168.x.x:3000), браузер сам відмовить у
 * реєстрації. Це обмеження самого браузера, не цього коду — тому помилку
 * тут просто тихо логуємо, а не показуємо користувачу: решта застосунку
 * працює абсолютно нормально і без PWA-можливостей.
 */
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  // Якщо контролер УЖЕ був до цього виклику — це не перше встановлення, а
  // оновлення вже встановленого SW. Саме тоді (і тільки тоді) варто
  // перезавантажити сторінку після активації нової версії, щоб підхопити
  // свіжі файли: на найпершому ж встановленні перезавантажувати нічого не
  // треба, сторінка й так щойно завантажилась з мережі.
  const hadController = !!navigator.serviceWorker.controller;

  navigator.serviceWorker.register('/sw.js').catch((err) => {
    console.warn('[pwa] Service worker не зареєстровано (можливо, немає HTTPS/localhost):', err);
  });

  if (!hadController) return;
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded) return;
    reloaded = true;
    location.reload();
  });
}
